import StackChartUtils from '../StackChartUtils';
import {
  compose,
  onlyUpdateForKeys,
  pure,
  withPropsOnChange,
} from 'react-recompose';
import {
  BaseCartesianChart,
  ShouldEnableReportLinkHOC,
} from '../base-cartesian-chart';
import { connect } from 'react-redux';
import StackBarPlot from './plot';
import NoDataIfHOC from '../NoDataIfHOC';
import { Viz } from '../../VizUtil';

class StackBarChart extends BaseCartesianChart {
  constructor(props) {
    super(props, [
      { shelf: 'VALUES', Plot: StackBarPlot, dataId: 'stackData' },
    ]);
  }
}

export default compose(
  pure,
  ShouldEnableReportLinkHOC,
  connect(
    BaseCartesianChart.mapStateToProps,
    BaseCartesianChart.mapDispatchToProps,
  ),
  withPropsOnChange(['queryResults', 'i18nPrefs'], props => {
    const customFormatToggles = Viz.getCustomFormatTogglesFromViz(props.viz);
    const stackData = StackChartUtils.transformResult(
      props.queryResults,
      props.viz,
      customFormatToggles,
      'VALUES',
      false,
      undefined,
      props.i18nPrefs,
    );
    const legendData = StackChartUtils.getUniqueStackNames({
      queryResults: props.queryResults,
      layout: props.viz.layout,
      viz: props.viz,
      i18nPrefs: props.i18nPrefs,
    });
    return { stackData, legendData };
  }),
  onlyUpdateForKeys(['stackData', 'height', 'width', 'id', 'enableReportLink']),
  NoDataIfHOC(props => props.stackData.length === 0),
)(StackBarChart);
